import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { listingRequestKeys } from './listingRequestQueryKeys'
import { getListingRequestAgreements } from './listingRequestEndpoints'
import { parseAgreements } from './listingRequestParser'

// MOU / Seller Agreement documents + signing status for one request.
export function useListingRequestAgreementsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => listingRequestKeys.agreements(toValue(id)),
    queryFn: () => getListingRequestAgreements(toValue(id)).then(parseAgreements),
    enabled: () => Boolean(toValue(id)),
  })
}
